import { LessonGroupExamsPage } from "@/pages/groups/toets-overzicht/LessonGroupExamsPage"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"
import { useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/groepen/$groupId/toets-overzicht/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "groups"),
})

function RouteComponent() {
  const { groupId } = useParams({
    from: "/beheer/groepen/$groupId/toets-overzicht/",
  })

  return <LessonGroupExamsPage groupId={Number(groupId)} />
}
